import React, {useMemo} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../stores";
import {Grid} from "@mui/material";
import {ShadcnQuarterDatePicker} from "../../../../shadcn/components/ui/ShadcnQuarterDatePicker";
import {SearchComponent} from "../../../../components/SearchComponet";
import {PpvFilterModal} from "../modals/PpvFilterModal";
import {
    ApiDropdownFilterComponent
} from "../../../../components/visualization/api-dropdown-filter/ApiDropdownFilterComponent";
import {
    PPV_FILTERS_ENABLE_BU,
    PPV_FILTERS_ENABLE_CC_DESCRIPTION,
    PPV_FILTERS_ENABLE_PART,
    PPV_FILTERS_ENABLE_SUPPLIER
} from "../classes/PpvConfig";

export const PpvFilterBarComponent: React.FC = observer(() => {
    const {p, ppvControllerStore, materializedApi} = useStores();
    const filterController = ppvControllerStore.ppvPageController.ppvPageFilterController;
    const filter = filterController.activeFilter;

    // The default values are memoize to avoid re-rendering the dropdowns
    // This way we can set the default when navigating to the page, and at the same time use the changes to update the filters
    // This is using a MUI-uncontrolled architecture: see https://mui.com/material-ui/react-text-field/#uncontrolled-vs-controlled
    const {pNameDefault, sNameDefault, ccDefault, buDefault} = useMemo(() => ({
        pNameDefault: filterController.pNameFilter,
        sNameDefault: filterController.supplierFilter,
        ccDefault: filterController.ccDescriptionFilter,
        buDefault: filterController.businessUnitFilter,
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [])

    // Skip rendering, to reduce useless API calls
    if (filter.databag === -1) return <></>

    // Note: A reset button might be usefull, but difficult to add with this architecture.
    // We need to switch to a controlled state for these dropdowns and filters.

    return <>
        {/*<p>filter = {JSON.stringify(filter)}</p>*/}
        <PpvFilterModal/>

        <Grid container alignItems="center">
            <Grid item style={{flexBasis: '16em'}}>
                <ShadcnQuarterDatePicker
                    // Controlled component
                    onUpdate={(values) => {
                        const startDate = values.range.from?.format(' YYYY-MM-DD') || '';
                        const endDate = values.range.to?.format(' YYYY-MM-DD') || '';
                        filterController.dateFilterChanged(startDate, endDate)
                    }}
                    dateFrom={filterController.startDate}
                    dateTo={filterController.startDate}
                />
            </Grid>
            <Grid item md={3} lg={3}>
                <SearchComponent
                    // Controlled component
                    className="ppv-search-component"
                    searchFieldLabel="Search by description"
                    sm={filterController.ppvSearchManager}
                    componentId="ppv-search"
                    fullWidth
                />
            </Grid>
            {/*<Grid item md={4} lg={4}>*/}
            <Grid item style={{marginLeft: 'auto'}}>
                {PPV_FILTERS_ENABLE_PART && <ApiDropdownFilterComponent
                    // Uncontrolled component
                    sx={{m: '0.5em'}}
                    label={p.partDataName}
                    getOptions={search => materializedApi.listPpvSearchPName(search, filter)
                        .then(resp => ({
                            ...resp.data,
                            results: resp.data.results.map(obj => ({id: obj.p_name, label: obj.p_name, obj}))
                        }))
                    }
                    defaultOption={pNameDefault}
                    onSelectionChange={selection => filterController.setPNameFilter(selection)}
                />}
                {PPV_FILTERS_ENABLE_SUPPLIER && <ApiDropdownFilterComponent
                    // Uncontrolled component
                    sx={{m: '0.5em'}}
                    label={p.supplierDataName}
                    getOptions={search => materializedApi.listPpvSearchSuppliers(search, filter)
                        .then(resp => ({
                            ...resp.data,
                            results: resp.data.results.map(obj => ({id: obj.id, label: obj.s_name, obj}))
                        }))
                    }
                    defaultOption={sNameDefault}
                    onSelectionChange={selection => filterController.setSupplierFilter(selection)}
                />}
                {PPV_FILTERS_ENABLE_CC_DESCRIPTION && <ApiDropdownFilterComponent
                    // Uncontrolled component
                    sx={{m: '0.5em'}}
                    label={p.ccDescriptionDataName}
                    getOptions={search => materializedApi.listPpvSearchCCDescription(search, filter)
                        .then(resp => ({
                            ...resp.data,
                            results: resp.data.results.map(obj => ({
                                id: obj.cc_description,
                                label: obj.cc_description,
                                obj
                            }))
                        }))
                    }
                    defaultOption={ccDefault}
                    onSelectionChange={selection => filterController.setCcDescriptionFilter(selection)}
                />}
                {PPV_FILTERS_ENABLE_BU && <ApiDropdownFilterComponent
                    // Uncontrolled component
                    sx={{m: '0.5em'}}
                    label={p.buDataName}
                    getOptions={search => materializedApi.listPpvSearchBusinessUnits(search, filter)
                        .then(resp => ({
                            ...resp.data,
                            results: resp.data.results.map(obj => ({id: obj.id, label: obj.bu_name, obj}))
                        }))
                    }
                    defaultOption={buDefault}
                    onSelectionChange={selection => filterController.setBusinessUnitFilter(selection)}
                />}
            </Grid>
            {/*<Grid item style={{marginLeft: 'auto'}}>*/}
            {/*    <Button*/}
            {/*        endIcon={<FilterAlt/>}*/}
            {/*        variant='outlined'*/}
            {/*        onClick={() => {*/}
            {/*            filterController.setFilterDialogOpen(true)*/}
            {/*        }}>*/}
            {/*        Filter*/}
            {/*    </Button>*/}
            {/*</Grid>*/}
        </Grid>
    </>
})